export const data = [
    {
      name: "Life Sciences",
      icon: "/lifesciences.png",
      description: "Our unmatched portfolio of solutions and products in the Lifesciences industry has played a pivotal role in enabling the top 50 global pharma clients to make data-driven decisions, resulting in significant accomplishments and transformative results.",
      link:'/lifescience'
    },
    {
      name: "BFSI",
      icon: "/bfsi.png",
      description: "Through our industry-leading assets and accelerators in the BFSI sector, we have empowered top financial institutions globally to navigate the data landscape, enabling informed decision-making and driving remarkable outcomes.",
      link:'/bfsi'
    },
    {
      name: "Automotive",
      icon: "/automotive.png",
      description: "Our cutting-edge solutions and assets in the Automotive industry have propelled leading global companies to leverage data-driven insights, driving them towards informed decisions and remarkable outcomes.",
      link:'/automotive'
    },
    {
      name: "Retail",
      icon: "/retail.png",
      description: "By harnessing our comprehensive solutions and accelerators tailored for the Retail industry, top organizations worldwide have gained a competitive edge, transforming data into strategic decisions and achieving remarkable results.",
      link:'/retail'
    }]